/**
 * Accurate detail fields extracted from the original captured charts.
 * The roster (mockClients.generated) only carries list-level fields, so richer
 * face-sheet data lives here, keyed by client id. Values are real, not mocked —
 * only clients we actually captured in full appear here.
 */
export interface ClientExtras {
  gender?: string
  maritalStatus?: string
  primaryLanguage?: string
  secondaryLanguage?: string
  email?: string
  address?: string
  city?: string
  state?: string
  zip?: string
  medicaidId?: string
  medicareId?: string
  physicianName?: string
  physicianPhone?: string
  physicianFax?: string
  admissionDate?: string
  careManager?: string
  program?: string
}

const EXTRAS: Record<string, ClientExtras> = {
  '44021': {
    gender: 'Female',
    maritalStatus: 'Widowed',
    primaryLanguage: 'Vietnamese',
    address: '11368 Eaton St',
    city: 'Westminster',
    state: 'Colorado',
    zip: '80020',
    medicaidId: 'R703926',
    medicareId: '524-83-6449-M',
    physicianName: 'Khoi Nguyen',
    physicianPhone: '303-975-0696',
    physicianFax: '888-615-4224',
  },
}

export function getClientExtras(id: string): ClientExtras {
  return EXTRAS[id] || {}
}
